module.exports = __webpack_public_path__ + "img/green-1-diamond-solid.378f8d1a.svg";